import { get, isString, trim, words, first, last, toUpper, isEmpty, capitalize } from 'lodash';
import { getDictionaryText } from './getDictionaryText';

/* eslint-disable quotes */
const specialCharacterArray = [
  { char: `&`, replaceWith: 'and' },
  { char: `'`, replaceWith: `\'` },
  { char: `"`, replaceWith: `\"` },
]

export const getStringToShowInCalendar = (str) => {
  let finalString = '';
  if (str) {
    finalString = str.replace(/(\r\n|\n|\r)/gm, " ");

    specialCharacterArray.forEach(item => {
      const regularExp = new RegExp(item.char, 'g');
      if (finalString && finalString.indexOf(item.char) >= 0) {
        finalString = finalString.replace(regularExp, item.replaceWith);
      }
    });

    return finalString;
  }
  return '';
}

export const getFormattedFullName = (fullName, isRTL = false) => {
  try {
    if (!isString(fullName) || isEmpty(trim(fullName))) return '';

    const parts = words(fullName);
    if (parts.length < 2) return fullName;

    const firstName = capitalize(first(parts));
    const lastNameInitial = toUpper(get(last(parts), 0, ''));

    return `${firstName} ${lastNameInitial}${isRTL ? '' : '.'}`;
  } catch (error) {
    console.error(error);
    return '';
  }
};

export const getTimeAgo = (dateString) => {
  try {
    const now = new Date();
    const past = new Date(dateString);
    const diff = Math.floor((now - past) / 1000); // Difference in seconds
    const ago = getDictionaryText('3DAgo');

    if (diff < 60) return `${diff} ${getDictionaryText(diff === 1 ? '3DSecond' : '3DSeconds')} ${ago}`;
    const minutes = Math.floor(diff / 60);
    if (minutes < 60) return `${minutes} ${getDictionaryText(minutes === 1 ? '3DMinute' : '3DMinutes')} ${ago} `;
    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} ${getDictionaryText(hours === 1 ? '3DHour' : '3DHours')} ${ago} `;
    const days = Math.floor(hours / 24);
    if (days < 7) return `${days} ${getDictionaryText(days === 1 ? '3DDay' : '3DDays')} ${ago}`;
    const weeks = Math.floor(days / 7);
    if (weeks <= 4) return `${weeks} ${getDictionaryText(weeks === 1 ? '3DWeek' : '3DWeeks')} ${ago} `;
    const months = Math.floor(days / 30);
    if (months < 12) return `${months} ${getDictionaryText(months === 1 ? '3DMonth' : '3DMonths')} ${ago} `;
    const years = Math.floor(days / 365);
    return `${years} ${getDictionaryText(years === 1 ? '3DYear' : '3DYears')} ${ago} `;
  } catch (error) {
    console.error(error);
    return '';
  }
};